import { Navigate, Outlet } from "react-router-dom";
import { useAppStateContext } from "../common/utils/AppStateContext"
import { InternalNavBar } from "./NavBar";
import OfflineProcessor from "../common/components/OfflineProcessor";
import { useEpcrAllergyDefs } from "../reducers/epcrAllergySlice";
import { useEpcrDispositions } from "../reducers/epcrDispositionSlice";
import { useEpcrHistoryDefs } from "../reducers/epcrHistorySlice";
import { useEpcrMedicationDefs } from "../reducers/epcrMedicationSlice";
import { useEpcrProcedureDefs } from "../reducers/epcrProcedureSlice";
import { useEpcrTreatmentMedicationDefs } from "../reducers/epcrTreatmentMedicationSlice";
import { useEpcrVitalDefs } from "../reducers/epcrVitalSlice";
import useClientConfig from "../common/hooks/clientConfigHook";
import { Fragment, useMemo } from "react";
import { useProblems } from "../reducers/problemSlice";
import { useListDataForLists, useListDefs } from "../reducers/listSlice";
import { useSites } from "../reducers/siteSlice";
import { useLevels } from "../reducers/levelSlice";
import { useTypes } from "../reducers/typeSlice";
import { usePriorities } from "../reducers/prioritySlice";
import { useActiveJobs } from "../reducers/jobSlice";
import { useJobStatuses } from "../reducers/jobStatusSlice";
import { useJobTags } from "../reducers/jobTagSlice";
import { useLocations } from "../reducers/locationSlice";
import { useEvents } from "../reducers/eventSlice";
import { useIndependentEpcrs, useJobsEpcrs } from "../reducers/epcrSlice";
import { useEpcrComplaints } from "../reducers/epcrComplaintSlice";


const EpcrHolder = ({ children }) => {
    useEpcrAllergyDefs();
    useEpcrDispositions();
    useEpcrHistoryDefs();
    useEpcrMedicationDefs();
    useEpcrProcedureDefs();
    useEpcrTreatmentMedicationDefs();
    useEpcrVitalDefs();
    useEpcrComplaints();
    useProblems();
    const lists = useListDefs();
    const listids = useMemo(() => lists.filter(list => list.available_offline).map(list => list.id), [lists]);
    useListDataForLists(listids);

    return children;
}

const JobHolder = ({ children }) => {
    useSites();
    useLevels();
    useTypes();
    usePriorities();
    useActiveJobs();
    useJobStatuses();
    useJobTags();
    useLocations();
    useProblems();
    return children;
}

const IndependentEpcrHolder = ({ children }) => {
    useIndependentEpcrs();
    return children;
}

const JobEpcrHolder = ({ children }) => {
    const jobs = useActiveJobs();
    const jobids = useMemo(() => jobs.map(j => j.jobid), [jobs]);
    useJobsEpcrs(jobids);
    return children;
}

const EventHolder = ({ children }) => {
    useEvents();
    return children;
}

export const RequireAuth = () => {
    const { token } = useAppStateContext();
    const clientConfig = useClientConfig();
    
    if (!token) {
        return <Navigate to="/signin" replace></Navigate>;
    }
    
    const EpcrSensei = clientConfig.enableOfflineMode && clientConfig.enablePCR ? EpcrHolder : Fragment;
    const JobSensei = clientConfig.enableOfflineMode && !clientConfig.epcrOnly ? JobHolder : Fragment
    const IndependentEpcrSensei = clientConfig.enableOfflineMode && clientConfig.hasIndependentEPCR ? IndependentEpcrHolder : Fragment;
    const JobEpcrSensei = clientConfig.enableOfflineMode && clientConfig.enablePCR && !clientConfig.epcrOnly ? JobEpcrHolder : Fragment;
    const EventSensei = clientConfig.enableOfflineMode && clientConfig.enableEvents ? EventHolder : Fragment;

    return <OfflineProcessor>
        <EpcrSensei>
            <JobSensei>
                <IndependentEpcrSensei>
                    <JobEpcrSensei>
                        <EventSensei>
                            <InternalNavBar>
                                <Outlet></Outlet>
                            </InternalNavBar>
                        </EventSensei>
                    </JobEpcrSensei>
                </IndependentEpcrSensei>
            </JobSensei>
        </EpcrSensei>
    </OfflineProcessor>
}